import SearchIcon from "@mui/icons-material/Search";
import { InputAdornment, InputAdornmentOwnProps } from "@mui/material";
import React from "react";
import { COMPONENT_IDS } from "../../../../helpers/constants/componentIds";

interface TableHeaderSearchIconProps {
  position?: InputAdornmentOwnProps["position"];
}

export const TableHeaderSearchIcon: React.FC<TableHeaderSearchIconProps> = React.memo(
  ({ position = "start" }: TableHeaderSearchIconProps) => {
    return (
      <InputAdornment position={position}>
        <SearchIcon data-testid={COMPONENT_IDS.TABLE_HEADER_SEARCH_ICON} />
      </InputAdornment>
    );
  },
);
